import { focusStrokeOuter, focusStrokeThickness } from '@adaptive-web/adaptive-ui/reference';
import { AdaptiveDesignSystem, textAreaAestheticStyles, textAreaStyleModules, textAreaTemplateStyles, composeTextArea } from "@adaptive-web/adaptive-web-components";
import { css } from "@microsoft/fast-element";

export const customTextAreaDefinition = composeTextArea(AdaptiveDesignSystem, {
  shadowOptions: {
    delegatesFocus: true,
  },
  styleModules: textAreaStyleModules,
  styles: [
    textAreaTemplateStyles,
    textAreaAestheticStyles,
    css`
      textarea {
        background-color: var(--background-color) !important;
      }

      :host([disabled]) .label,
      :host([disabled]) .control {
        color: var(--text-color) !important;
      }

      :host .control:autofill,
      :host .control:-webkit-autofill,
      :host .control:autofill:focus,
      :host .control:-webkit-autofill:focus,
      :host .control:-internal-autofill-selected {
        -webkit-box-shadow: 0 0 0 1000px var(--background-color) inset !important;
      }

      :host(:focus-within) .control {
        outline: ${focusStrokeThickness} solid ${focusStrokeOuter};
        outline-offset: 1px;
      }
    `
  ],
});